module.exports = __webpack_public_path__ + "static/media/img_swap.5981a20f.png";